var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links"},[_c('z-title',[_vm._v("ネット販売")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rows"},[_c('p',{staticClass:"word block-word"},[_vm._v("オンライン販売は準備中です")])])
}]

export { render, staticRenderFns }